<template>
    <div class="flex mt-[42px] mb-[27px] justify-between h-[42px]">
        <h1
            class="text-[21px] font-medium leading-normal tracking-small text-gray-800"
        >
            {{ $t("vue.account_settings") }}
        </h1>
    </div>

    <SettingsTabs
        class="mt-[24px] mb-[100px]"
        tab-key="team-settings-mcp-server"
    >
        <div
            class="mt-[44px] rounded-md bg-white px-[21px] py-[21px] shadow-card"
        >
            <div
                class="flex flex-col gap-4 sm:flex-row sm:items-start sm:gap-[22px]"
            >
                <div
                    class="mt-[6px] flex h-[78px] w-[78px] shrink-0 items-center justify-center"
                >
                    <svg
                        width="78"
                        height="78"
                        viewBox="0 0 78 78"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            cx="38.9999"
                            cy="38.9999"
                            r="38.9999"
                            fill="var(--DMARC-black, #1F2938)"
                        />
                        <g clip-path="url(#clip0_6089_41555)">
                            <g
                                transform="translate(14.7985 14.7985) scale(0.6205512821)"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M50.986 7.61474C49.4157 6.08647 47.3109 5.23135 45.1197 5.23135C42.9285 5.23135 40.8238 6.08647 39.2535 7.61474L7.96897 38.2947C7.44545 38.8036 6.74416 39.0883 6.01409 39.0883C5.28403 39.0883 4.58273 38.8036 4.05922 38.2947C3.80291 38.0455 3.59918 37.7474 3.46006 37.418C3.32094 37.0887 3.24927 36.7348 3.24927 36.3772C3.24927 36.0197 3.32094 35.6658 3.46006 35.3365C3.59918 35.0071 3.80291 34.709 4.05922 34.4597L35.3437 3.77974C37.9607 1.23302 41.4681 -0.191956 45.1197 -0.191956C48.7713 -0.191956 52.2788 1.23302 54.8957 3.77974C56.4099 5.25233 57.5539 7.06256 58.2341 9.06226C58.9142 11.062 59.1111 13.1943 58.8087 15.2847C60.9269 14.9835 63.086 15.1726 65.1196 15.8375C67.1531 16.5024 69.0069 17.6253 70.538 19.1197L70.7005 19.2822C71.982 20.5286 73.0007 22.0191 73.6963 23.6659C74.3918 25.3126 74.7502 27.0821 74.7502 28.8697C74.7502 30.6574 74.3918 32.4269 73.6963 34.0736C73.0007 35.7203 71.982 37.2109 70.7005 38.4572L42.406 66.2025C42.3206 66.2855 42.2527 66.3848 42.2063 66.4945C42.16 66.6042 42.1361 66.722 42.1361 66.8411C42.1361 66.9602 42.16 67.0781 42.2063 67.1878C42.2527 67.2975 42.3206 67.3968 42.406 67.4797L48.217 73.1802C48.4733 73.4295 48.677 73.7276 48.8161 74.057C48.9552 74.3863 49.0269 74.7402 49.0269 75.0977C49.0269 75.4553 48.9552 75.8092 48.8161 76.1385C48.677 76.4679 48.4733 76.766 48.217 77.0152C47.6935 77.5241 46.9922 77.8088 46.2621 77.8088C45.532 77.8088 44.8307 77.5241 44.3072 77.0152L38.4962 71.318C37.8977 70.7364 37.4219 70.0407 37.097 69.272C36.7721 68.5033 36.6048 67.6773 36.6048 66.8427C36.6048 66.0082 36.7721 65.1822 37.097 64.4135C37.4219 63.6448 37.8977 62.9491 38.4962 62.3675L66.7907 34.619C67.5592 33.871 68.1701 32.9766 68.5872 31.9885C69.0043 31.0005 69.2192 29.9389 69.2192 28.8665C69.2192 27.794 69.0043 26.7325 68.5872 25.7445C68.1701 24.7564 67.5592 23.862 66.7907 23.114L66.6282 22.9547C65.0596 21.4281 62.9577 20.573 60.7688 20.5712C58.58 20.5694 56.4766 21.4209 54.9055 22.945L31.5965 45.8055L31.59 45.812L31.2715 46.1272C30.7478 46.6371 30.0458 46.9223 29.315 46.9223C28.5841 46.9223 27.8821 46.6371 27.3585 46.1272C27.1022 45.878 26.8984 45.5799 26.7593 45.2505C26.6202 44.9212 26.5485 44.5673 26.5485 44.2097C26.5485 43.8522 26.6202 43.4983 26.7593 43.169C26.8984 42.8396 27.1022 42.5415 27.3585 42.2922L50.9957 19.11C51.7621 18.3615 52.3709 17.4671 52.7863 16.4797C53.2017 15.4922 53.4152 14.4316 53.4143 13.3603C53.4134 12.289 53.1981 11.2288 52.781 10.242C52.364 9.25526 51.7536 8.36196 50.986 7.61474Z"
                                    fill="#FFFFFF"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M47.0761 15.2848C47.3324 15.0355 47.5361 14.7374 47.6752 14.408C47.8143 14.0787 47.886 13.7248 47.886 13.3673C47.886 13.0097 47.8143 12.6558 47.6752 12.3265C47.5361 11.9971 47.3324 11.699 47.0761 11.4498C46.5524 10.9399 45.8504 10.6547 45.1196 10.6547C44.3887 10.6547 43.6867 10.9399 43.1631 11.4498L20.0263 34.1413C18.7448 35.3876 17.7261 36.8781 17.0305 38.5249C16.3349 40.1716 15.9766 41.9411 15.9766 43.7288C15.9766 45.5164 16.3349 47.2859 17.0305 48.9326C17.7261 50.5794 18.7448 52.0699 20.0263 53.3163C22.6437 55.8622 26.151 57.2867 29.8023 57.2867C33.4537 57.2867 36.961 55.8622 39.5783 53.3163L62.7183 30.6248C62.9746 30.3755 63.1783 30.0774 63.3175 29.748C63.4566 29.4187 63.5283 29.0648 63.5283 28.7073C63.5283 28.3497 63.4566 27.9958 63.3175 27.6665C63.1783 27.3371 62.9746 27.039 62.7183 26.7898C62.1946 26.2799 61.4927 25.9947 60.7618 25.9947C60.031 25.9947 59.329 26.2799 58.8053 26.7898L35.6686 49.4813C34.0983 51.0095 31.9935 51.8646 29.8023 51.8646C27.6111 51.8646 25.5064 51.0095 23.9361 49.4813C23.1675 48.7332 22.5567 47.8388 22.1396 46.8508C21.7225 45.8628 21.5076 44.8012 21.5076 43.7288C21.5076 42.6563 21.7225 41.5947 22.1396 40.6067C22.5567 39.6187 23.1675 38.7243 23.9361 37.9763L47.0761 15.2848Z"
                                    fill="#FFFFFF"
                                />
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_6089_41555">
                                <rect width="78" height="78" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div>
                    <h3 class="text-[14px] font-medium text-gray-800">
                        {{ $t("vue.mcp_server_title") }}
                    </h3>
                    <p
                        class="mt-2 text-[12.25px] leading-relaxed text-gray-500"
                    >
                        {{ $t("vue.mcp_server_description") }}
                    </p>
                    <div
                        class="mt-[20px] flex flex-wrap items-center gap-[14px]"
                    >
                        <AtomicButton
                            color="light-blue"
                            size="sm"
                            @click="openMcpArticle"
                        >
                            <span>{{ $t("vue.mcp_learn_more_article") }}</span>
                            <svg
                                class="ml-1.5 h-3 w-3 shrink-0 text-current"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M7.5 3H10.5C11.3284 3 12 3.67157 12 4.5C12 5.26925 11.4209 5.90326 10.6749 5.98991L10.5 6H7.5C6.73075 6 6.09674 6.57906 6.01009 7.32507L6 7.5V28.5C6 29.2692 6.57906 29.9033 7.32507 29.9899L7.5 30H28.5C29.2692 30 29.9033 29.4209 29.9899 28.6749L30 28.5V25.5C30 24.6716 30.6716 24 31.5 24C32.2692 24 32.9033 24.5791 32.9899 25.3251L33 25.5V28.5C33 30.8965 31.1266 32.8555 28.7644 32.9924L28.5 33H7.5C5.10348 33 3.14451 31.1266 3.00764 28.7644L3 28.5V7.5C3 5.10348 4.87338 3.14451 7.23559 3.00764L7.5 3ZM31.5 3L31.6215 3.0045L31.8011 3.03036L31.9682 3.07461L32.1348 3.14051L32.2811 3.21899L32.4251 3.31918L32.5607 3.43934L32.7055 3.60704L32.813 3.77391L32.8595 3.86535L32.9102 3.98752L32.9462 4.10101L32.9896 4.32286L33 4.5V13.5C33 14.3284 32.3284 15 31.5 15C30.6716 15 30 14.3284 30 13.5V8.121L20.5607 17.5607C20.0199 18.1014 19.1691 18.143 18.5806 17.6854L18.4393 17.5607C17.8986 17.0199 17.857 16.1691 18.3146 15.5806L18.4393 15.4393L27.876 6H22.5C21.6716 6 21 5.32843 21 4.5C21 3.67157 21.6716 3 22.5 3H31.5Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </AtomicButton>
                        <AtomicButton
                            color="light-blue"
                            size="sm"
                            @click="openMcpDocs"
                        >
                            <span>{{ $t("vue.mcp_read_docs") }}</span>
                            <svg
                                class="ml-1.5 h-3 w-3 shrink-0 text-current"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M7.5 3H10.5C11.3284 3 12 3.67157 12 4.5C12 5.26925 11.4209 5.90326 10.6749 5.98991L10.5 6H7.5C6.73075 6 6.09674 6.57906 6.01009 7.32507L6 7.5V28.5C6 29.2692 6.57906 29.9033 7.32507 29.9899L7.5 30H28.5C29.2692 30 29.9033 29.4209 29.9899 28.6749L30 28.5V25.5C30 24.6716 30.6716 24 31.5 24C32.2692 24 32.9033 24.5791 32.9899 25.3251L33 25.5V28.5C33 30.8965 31.1266 32.8555 28.7644 32.9924L28.5 33H7.5C5.10348 33 3.14451 31.1266 3.00764 28.7644L3 28.5V7.5C3 5.10348 4.87338 3.14451 7.23559 3.00764L7.5 3ZM31.5 3L31.6215 3.0045L31.8011 3.03036L31.9682 3.07461L32.1348 3.14051L32.2811 3.21899L32.4251 3.31918L32.5607 3.43934L32.7055 3.60704L32.813 3.77391L32.8595 3.86535L32.9102 3.98752L32.9462 4.10101L32.9896 4.32286L33 4.5V13.5C33 14.3284 32.3284 15 31.5 15C30.6716 15 30 14.3284 30 13.5V8.121L20.5607 17.5607C20.0199 18.1014 19.1691 18.143 18.5806 17.6854L18.4393 17.5607C17.8986 17.0199 17.857 16.1691 18.3146 15.5806L18.4393 15.4393L27.876 6H22.5C21.6716 6 21 5.32843 21 4.5C21 3.67157 21.6716 3 22.5 3H31.5Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </AtomicButton>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-[44px]">
            <h3 class="text-[21px] font-medium text-gray-800">
                {{ $t("vue.supported_tools") }}
            </h3>

            <div class="mt-[21px] rounded-md bg-white pt-[21px] shadow-card">
                <div class="relative px-[21px]">
                    <div class="mb-[34px]">
                        <p
                            class="mt-1 font-inter text-[12.25px] font-normal not-italic leading-[142%] text-[#4B5563]"
                        >
                            {{ $t("vue.supported_tools_explanation") }}
                        </p>
                    </div>
                </div>

                <div class="relative px-[21px]">
                    <div class="space-y-4">
                        <div
                            v-for="tool in visibleTools"
                            :key="tool.name"
                            class="flex flex-col gap-3 sm:grid sm:grid-cols-[217px_1fr] sm:items-start sm:gap-[51px]"
                        >
                            <span
                                class="inline-flex w-fit items-center rounded-md bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-700"
                                :title="$t(tool.titleKey)"
                            >
                                {{ tool.name }}
                            </span>
                            <div class="text-[12.25px] text-gray-600">
                                <p class="font-medium text-gray-700">
                                    {{ $t(tool.titleKey) }}
                                </p>
                                <p class="mt-1 leading-relaxed text-gray-500">
                                    {{ $t(tool.descriptionKey) }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="hasMoreTools && !showAllTools"
                        class="pointer-events-none absolute inset-x-0 bottom-0 h-12 backdrop-blur-[2px]"
                    ></div>
                </div>
                <button
                    v-if="hasMoreTools"
                    type="button"
                    class="mt-4 w-full h-[49px] border-t border-[#EDEFF1] cursor-pointer text-center text-xs font-medium text-blue-600 transition hover:text-blue-700"
                    :aria-expanded="showAllTools.toString()"
                    @click="toggleTools"
                >
                    {{
                        showAllTools
                            ? $t("vue.mcp_hide_tools")
                            : $t("vue.mcp_show_all_tools")
                    }}
                </button>
            </div>
        </div>

        <div class="mt-[44px]">
            <h3 class="text-[21px] font-medium text-gray-800">
                {{ $t("vue.installation_instructions") }}
            </h3>
            <div class="mt-[21px] border-b border-gray-200">
                <div class="flex gap-6">
                    <button
                        v-for="tab in installTabs"
                        :key="tab.key"
                        type="button"
                        class="relative flex items-center gap-2 py-3 px-[14px] text-sm font-medium transition cursor-pointer"
                        :class="{
                            'text-gray-800': tab.key === activeInstallTab,
                            'text-gray-500 hover:text-gray-700':
                                tab.enabled && tab.key !== activeInstallTab,
                            'cursor-not-allowed text-gray-400 opacity-60':
                                !tab.enabled,
                        }"
                        :aria-disabled="(!tab.enabled).toString()"
                        :disabled="!tab.enabled"
                        @click="selectInstallTab(tab)"
                    >
                        <svg
                            v-if="tab.key === 'chatgpt'"
                            :class="[
                                'h-5 w-5',
                                tab.key === activeInstallTab
                                    ? 'opacity-100'
                                    : 'opacity-60',
                            ]"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <g clip-path="url(#clip0_6089_41606)">
                                <path
                                    d="M0.00830078 4.80797C0.00830078 2.1571 2.1571 0.00830078 4.80797 0.00830078H15.1912C17.8429 0.00830078 19.9917 2.1571 19.9917 4.80797V20H4.80797C2.1571 20 0.00830078 17.8512 0.00830078 15.2003V4.80797Z"
                                    fill="#74AA9C"
                                />
                                <path
                                    d="M9.20441 2.48631C7.55853 2.48631 6.09634 3.5445 5.58678 5.10726L5.40308 6.18041V9.73735C5.40308 9.91524 5.49451 10.0732 5.64747 10.1646L8.51114 11.8148V6.92687H8.51197V6.69495L11.4106 5.0208C11.6908 4.85854 11.9961 4.74768 12.3122 4.68973L12.0332 3.74317C11.3133 2.93851 10.2834 2.48132 9.20441 2.48631ZM9.20441 3.46303L9.19942 3.46802C9.86192 3.46802 10.4987 3.69661 11.0082 4.11972C10.9874 4.1297 10.9467 4.15547 10.9168 4.17043L7.92012 5.89612C7.76717 5.98257 7.67573 6.14549 7.67573 6.32338V10.3741L6.38645 9.63095V6.28265C6.38562 4.72738 7.64664 3.46553 9.20441 3.46303Z"
                                    fill="white"
                                />
                                <path
                                    d="M16.1094 5.55421C15.2864 4.12884 13.6389 3.39165 12.0308 3.73174L11.0095 4.10922L7.92912 5.88769C7.77506 5.97663 7.68401 6.13479 7.68129 6.31297L7.68404 9.61806L11.9171 7.17411L11.9175 7.17483L12.1184 7.05887L15.0175 8.73205C15.2982 8.89363 15.5468 9.10257 15.7551 9.34737L16.4353 8.63242C16.7722 7.60667 16.6532 6.48614 16.1094 5.55421ZM15.2635 6.04258L15.2567 6.04075C15.5879 6.61449 15.7083 7.28023 15.5967 7.93308C15.5777 7.92007 15.535 7.89768 15.5071 7.87925L12.5142 6.14689C12.3629 6.05766 12.1761 6.05993 12.022 6.14888L8.51401 8.17423L8.51295 6.68611L11.4127 5.01197C12.7592 4.23361 14.4825 4.69476 15.2635 6.04258Z"
                                    fill="white"
                                />
                                <path
                                    d="M16.9047 13.0679C17.7277 11.6425 17.5423 9.84715 16.4437 8.62448L15.6062 7.92881L12.5258 6.15034C12.3717 6.06139 12.1892 6.06161 12.0336 6.14835L9.17266 7.80329L13.4057 10.2472L13.4053 10.248L13.6061 10.3639L13.6067 13.7112C13.6071 14.0351 13.5505 14.3549 13.4426 14.6576L14.4019 14.8893C15.4587 14.6682 16.3696 14.0048 16.9047 13.0679ZM16.0589 12.5795L16.057 12.5727C15.7258 13.1465 15.2094 13.5836 14.5882 13.8134C14.59 13.7904 14.588 13.7422 14.59 13.7088L14.5939 10.2508C14.5955 10.0751 14.5001 9.91444 14.3461 9.8255L10.838 7.80014L12.1263 7.05517L15.026 8.72932C16.3733 9.50623 16.8356 11.2292 16.0589 12.5795Z"
                                    fill="white"
                                />
                                <path
                                    d="M10.7956 17.5137C12.4415 17.5137 13.9037 16.4555 14.4132 14.8927L14.5969 13.8196V10.2627C14.5969 10.0848 14.5055 9.92683 14.3525 9.83539L11.4889 8.18522L11.4889 13.0731H11.488V13.305L8.58944 14.9792C8.30919 15.1415 8.00391 15.2523 7.68778 15.3103L7.96683 16.2568C8.6867 17.0615 9.71662 17.5187 10.7956 17.5137ZM10.7956 16.537L10.8006 16.532C10.1381 16.532 9.50133 16.3034 8.99177 15.8803C9.01255 15.8703 9.05328 15.8445 9.08321 15.8296L12.0799 14.1039C12.2328 14.0174 12.3243 13.8545 12.3243 13.6766V9.62591L13.6135 10.3691V13.7174C13.6144 15.2726 12.3534 16.5345 10.7956 16.537Z"
                                    fill="white"
                                />
                                <path
                                    d="M3.89063 14.4458C4.71357 15.8712 6.36108 16.6084 7.96925 16.2683L8.99048 15.8908L12.0709 14.1123C12.2249 14.0234 12.316 13.8652 12.3187 13.687L12.316 10.3819L8.08291 12.8259L8.08249 12.8252L7.88164 12.9411L4.98249 11.268C4.70184 11.1064 4.45319 10.8974 4.24494 10.6526L3.56472 11.3676C3.2278 12.3933 3.34683 13.5139 3.89063 14.4458ZM4.7365 13.9574L4.74331 13.9592C4.41206 13.3855 4.29165 12.7198 4.4033 12.0669C4.42233 12.0799 4.46501 12.1023 4.49293 12.1208L7.48576 13.8531C7.6371 13.9423 7.82392 13.9401 7.97797 13.8511L11.486 11.8258L11.487 13.3139L8.58734 14.988C7.24085 15.7664 5.51754 15.3052 4.7365 13.9574Z"
                                    fill="white"
                                />
                                <path
                                    d="M3.09528 6.93209C2.27234 8.35746 2.45767 10.1528 3.55628 11.3755L4.3938 12.0712L7.4742 13.8497C7.62826 13.9386 7.81075 13.9384 7.96642 13.8516L10.8273 12.1967L6.59429 9.75276L6.5947 9.75204L6.39386 9.63608L6.39329 6.28876C6.3929 5.96492 6.44953 5.64511 6.55741 5.34236L5.59813 5.11074C4.54135 5.33184 3.63045 5.99518 3.09528 6.93209ZM3.94115 7.42045L3.94297 7.42727C4.27423 6.85353 4.79057 6.41638 5.41177 6.18664C5.41002 6.20963 5.41197 6.25779 5.40997 6.29118L5.40612 9.74922C5.40451 9.92491 5.49989 10.0856 5.65394 10.1745L9.16196 12.1999L7.87374 12.9448L4.97403 11.2707C3.62671 10.4938 3.16443 8.77077 3.94115 7.42045Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_6089_41606">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <svg
                            v-else-if="tab.key === 'claude'"
                            :class="[
                                'h-5 w-5',
                                tab.key === activeInstallTab
                                    ? 'opacity-100'
                                    : 'opacity-60',
                            ]"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M9.47989 19.9998L8.97989 19.6198L8.6999 18.9998L8.97989 17.7598L9.29989 16.1598L9.55989 14.8798L9.79988 13.2998L9.93988 12.7799L9.91988 12.7399L9.81989 12.7599L8.6199 14.3998L6.79992 16.8598L5.35994 18.3798L5.01994 18.5198L4.41995 18.2198L4.47995 17.6598L4.81994 17.1798L6.79992 14.6398L7.99991 13.0598L8.7799 12.1599L8.7599 12.0399H8.7199L3.43996 15.4798L2.49997 15.5998L2.07998 15.2198L2.13997 14.5998L2.33997 14.3998L3.91995 13.2998L7.85991 11.0999L7.91991 10.8999L7.85991 10.7999H7.65991L6.99992 10.7599L4.75994 10.6999L2.81997 10.6199L0.919989 10.5199L0.439995 10.4199L0 9.81989L0.0399995 9.51989L0.439995 9.25989L1.01999 9.29989L2.27997 9.39989L4.17995 9.51989L5.55993 9.59989L7.59991 9.81989H7.91991L7.95991 9.67989L7.85991 9.59989L7.77991 9.51989L5.79993 8.1999L3.67996 6.79992L2.55997 5.97993L1.95998 5.55993L1.65998 5.17994L1.53998 4.33995L2.07998 3.73996L2.81997 3.79996L2.99996 3.83995L3.73996 4.41995L5.31994 5.63993L7.39991 7.17992L7.69991 7.41991L7.83991 7.33991V7.27991L7.69991 7.05992L6.57992 5.01994L5.37994 2.93997L4.83994 2.07998L4.69994 1.55998C4.64661 1.37998 4.61995 1.17999 4.61995 0.959989L5.23994 0.119999L5.57993 0L6.41992 0.119999L6.75992 0.419996L7.27991 1.59998L8.09991 3.45996L9.39989 5.97993L9.77989 6.73992L9.97988 7.41991L10.0599 7.63991H10.1999V7.51991L10.2999 6.07993L10.4999 4.33995L10.6999 2.09998L10.7599 1.45998L11.0799 0.699993L11.6999 0.299997L12.1799 0.519995L12.5799 1.09999L12.5199 1.45998L12.2999 2.99996L11.8199 5.41994L11.5199 7.05992H11.6999L11.8999 6.83992L12.7199 5.75993L14.0998 4.03995L14.6998 3.35996L15.4198 2.59997L15.8798 2.23997H16.7398L17.3598 3.17996L17.0798 4.15995L16.1998 5.27994L15.4598 6.21993L14.3998 7.63991L13.7598 8.7799L13.8198 8.8599H13.9598L16.3398 8.3399L17.6398 8.1199L19.1598 7.85991L19.8598 8.1799L19.9398 8.4999L19.6598 9.17989L18.0198 9.57989L16.0998 9.95988L13.2398 10.6399L13.1998 10.6599L13.2398 10.7199L14.5198 10.8399L15.0798 10.8799H16.4398L18.9598 11.0599L19.6198 11.4999L19.9998 12.0199L19.9398 12.4399L18.9198 12.9398L17.5598 12.6199L14.3598 11.8599L13.2798 11.5999H13.1198V11.6799L14.0398 12.5799L15.6998 14.0798L17.7998 16.0198L17.8998 16.4998L17.6398 16.8998L17.3598 16.8598L15.5198 15.4598L14.7998 14.8398L13.1998 13.4998H13.0998V13.6398L13.4598 14.1798L15.4198 17.1198L15.5198 18.0198L15.3798 18.2998L14.8598 18.4798L14.3198 18.3798L13.1598 16.7798L11.9799 14.9598L11.0199 13.3398L10.9199 13.4198L10.3399 19.4598L10.0799 19.7598L9.47989 19.9998Z"
                                fill="#D97757"
                            />
                        </svg>
                        <svg
                            v-else
                            :class="[
                                'h-5 w-5',
                                tab.key === activeInstallTab
                                    ? 'opacity-100'
                                    : 'opacity-60',
                            ]"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <g>
                                <mask
                                    id="mask0_6089_41657"
                                    style="mask-type: alpha"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="20"
                                    height="20"
                                >
                                    <path
                                        d="M10 0C10.2097 0 10.3922 0.143243 10.4433 0.346717C10.6002 0.969084 10.8048 1.57614 11.0594 2.16668C11.7227 3.70753 12.6328 5.05621 13.7883 6.21171C14.9443 7.36719 16.2925 8.27731 17.8333 8.9406C18.4244 9.1952 19.031 9.39981 19.6533 9.55668C19.8568 9.60784 20 9.79029 20 10C20 10.2097 19.8568 10.3922 19.6533 10.4433C19.031 10.6002 18.4238 10.8048 17.8333 11.0594C16.2925 11.7227 14.9438 12.6328 13.7883 13.7883C12.6328 14.9444 11.7227 16.2925 11.0594 17.8333C10.8048 18.4244 10.6002 19.031 10.4433 19.6533C10.3922 19.8568 10.2097 20 10 20C9.79029 20 9.60784 19.8568 9.55668 19.6533C9.39981 19.031 9.1952 18.4238 8.9406 17.8333C8.27731 16.2925 7.36774 14.9438 6.21171 13.7883C5.05562 12.6328 3.70753 11.7227 2.16668 11.0594C1.57557 10.8048 0.969084 10.6002 0.346717 10.4433C0.143243 10.3922 0 10.2097 0 10C2.67404e-05 9.79029 0.143256 9.60784 0.346717 9.55668C0.969087 9.39981 1.57614 9.19523 2.16668 8.9406C3.70756 8.27728 5.05621 7.36722 6.21171 6.21171C7.36722 5.05621 8.27728 3.70756 8.9406 2.16668C9.19523 1.57557 9.39981 0.969087 9.55668 0.346717C9.60784 0.143256 9.79029 2.67404e-05 10 0Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M10 0C10.2097 0 10.3922 0.143243 10.4433 0.346717C10.6002 0.969084 10.8048 1.57614 11.0594 2.16668C11.7227 3.70753 12.6328 5.05621 13.7883 6.21171C14.9443 7.36719 16.2925 8.27731 17.8333 8.9406C18.4244 9.1952 19.031 9.39981 19.6533 9.55668C19.8568 9.60784 20 9.79029 20 10C20 10.2097 19.8568 10.3922 19.6533 10.4433C19.031 10.6002 18.4238 10.8048 17.8333 11.0594C16.2925 11.7227 14.9438 12.6328 13.7883 13.7883C12.6328 14.9444 11.7227 16.2925 11.0594 17.8333C10.8048 18.4244 10.6002 19.031 10.4433 19.6533C10.3922 19.8568 10.2097 20 10 20C9.79029 20 9.60784 19.8568 9.55668 19.6533C9.39981 19.031 9.1952 18.4238 8.9406 17.8333C8.27731 16.2925 7.36774 14.9438 6.21171 13.7883C5.05562 12.6328 3.70753 11.7227 2.16668 11.0594C1.57557 10.8048 0.969084 10.6002 0.346717 10.4433C0.143243 10.3922 0 10.2097 0 10C2.67404e-05 9.79029 0.143256 9.60784 0.346717 9.55668C0.969087 9.39981 1.57614 9.19523 2.16668 8.9406C3.70756 8.27728 5.05621 7.36722 6.21171 6.21171C7.36722 5.05621 8.27728 3.70756 8.9406 2.16668C9.19523 1.57557 9.39981 0.969087 9.55668 0.346717C9.60784 0.143256 9.79029 2.67404e-05 10 0Z"
                                        fill="url(#paint0_linear_6089_41657)"
                                    />
                                </mask>
                                <g mask="url(#mask0_6089_41657)">
                                    <g filter="url(#filter0_f_6089_41657)">
                                        <path
                                            d="M-1.80591 15.6358C0.504943 16.4565 3.16096 14.9177 4.12648 12.199C5.09199 9.48018 4.00138 6.6109 1.69052 5.79025C-0.620334 4.96959 -3.27636 6.50833 -4.24187 9.2271C-5.20738 11.9459 -4.11677 14.8152 -1.80591 15.6358Z"
                                            fill="#FFE432"
                                        />
                                    </g>
                                    <g filter="url(#filter1_f_6089_41657)">
                                        <path
                                            d="M8.45483 6.67195C11.6295 6.67195 14.2031 4.04177 14.2031 0.797281C14.2031 -2.44721 11.6295 -5.07739 8.45483 -5.07739C5.28014 -5.07739 2.70654 -2.44721 2.70654 0.797281C2.70654 4.04177 5.28014 6.67195 8.45483 6.67195Z"
                                            fill="#FC413D"
                                        />
                                    </g>
                                    <g filter="url(#filter2_f_6089_41657)">
                                        <path
                                            d="M6.22052 25.4593C9.53454 25.2973 12.0509 21.6857 11.8411 17.3925C11.6312 13.0993 8.77453 9.75035 5.46052 9.91235C2.1465 10.0744 -0.369906 13.686 -0.160036 17.9792C0.0498332 22.2723 2.90651 25.6213 6.22052 25.4593Z"
                                            fill="#00B95C"
                                        />
                                    </g>
                                    <g filter="url(#filter3_f_6089_41657)">
                                        <path
                                            d="M6.22052 25.4593C9.53454 25.2973 12.0509 21.6857 11.8411 17.3925C11.6312 13.0993 8.77453 9.75035 5.46052 9.91235C2.1465 10.0744 -0.369906 13.686 -0.160036 17.9792C0.0498332 22.2723 2.90651 25.6213 6.22052 25.4593Z"
                                            fill="#00B95C"
                                        />
                                    </g>
                                    <g filter="url(#filter4_f_6089_41657)">
                                        <path
                                            d="M9.53972 22.862C12.318 21.1716 13.0616 17.3218 11.2006 14.2631C9.33967 11.2045 5.57881 10.0954 2.80053 11.7858C0.0222568 13.4762 -0.721362 17.326 1.13961 20.3846C3.00059 23.4433 6.76145 24.5524 9.53972 22.862Z"
                                            fill="#00B95C"
                                        />
                                    </g>
                                    <g filter="url(#filter5_f_6089_41657)">
                                        <path
                                            d="M20.7694 13.2503C23.8922 13.2503 26.4236 10.8126 26.4236 7.80549C26.4236 4.79843 23.8922 2.36072 20.7694 2.36072C17.6467 2.36072 15.1152 4.79843 15.1152 7.80549C15.1152 10.8126 17.6467 13.2503 20.7694 13.2503Z"
                                            fill="#3186FF"
                                        />
                                    </g>
                                    <g filter="url(#filter6_f_6089_41657)">
                                        <path
                                            d="M-4.02644 12.6186C-1.15119 14.8051 3.04926 14.1191 5.35551 11.0864C7.66177 8.05366 7.2005 3.82263 4.32525 1.63611C1.45 -0.550412 -2.75045 0.13557 -5.0567 3.16829C-7.36296 6.20102 -6.90169 10.432 -4.02644 12.6186Z"
                                            fill="#FBBC04"
                                        />
                                    </g>
                                    <g filter="url(#filter7_f_6089_41657)">
                                        <path
                                            d="M10.7064 15.8505C14.1384 18.21 18.6875 17.5527 20.8672 14.3823C23.0469 11.2119 22.0318 6.72898 18.5998 4.36944C15.1679 2.0099 10.6187 2.66722 8.43903 5.83763C6.25932 9.00803 7.27446 13.4909 10.7064 15.8505Z"
                                            fill="#3186FF"
                                        />
                                    </g>
                                    <g filter="url(#filter8_f_6089_41657)">
                                        <path
                                            d="M16.9455 -0.72C17.8186 0.467105 16.6967 2.77522 14.4396 4.43531C12.1825 6.09542 9.64501 6.47884 8.7719 5.29174C7.89876 4.10465 9.0207 1.79653 11.2777 0.136431C13.5348 -1.52366 16.0724 -1.9071 16.9455 -0.72Z"
                                            fill="#749BFF"
                                        />
                                    </g>
                                    <g filter="url(#filter9_f_6089_41657)">
                                        <path
                                            d="M9.77816 4.96312C13.2687 1.72539 14.4668 -2.6583 12.4541 -4.82814C10.4415 -6.99797 5.98021 -6.13227 2.48965 -2.89453C-1.00091 0.343196 -2.19898 4.72689 -0.186312 6.89673C1.82635 9.06656 6.2876 8.20086 9.77816 4.96312Z"
                                            fill="#FC413D"
                                        />
                                    </g>
                                    <g filter="url(#filter10_f_6089_41657)">
                                        <path
                                            d="M2.62255 16.5926C4.69716 18.0774 7.07897 18.3031 7.94248 17.0966C8.80599 15.8901 7.82419 13.7083 5.74958 12.2235C3.67497 10.7387 1.29315 10.513 0.429646 11.7195C-0.43386 12.926 0.547934 15.1078 2.62255 16.5926Z"
                                            fill="#FFEE48"
                                        />
                                    </g>
                                </g>
                            </g>
                            <defs>
                                <filter
                                    id="filter0_f_6089_41657"
                                    x="-6.10984"
                                    y="4.05343"
                                    width="12.104"
                                    height="13.3192"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="0.758046"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter1_f_6089_41657"
                                    x="-4.62295"
                                    y="-12.4069"
                                    width="26.1556"
                                    height="26.4083"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="3.66475"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter2_f_6089_41657"
                                    x="-6.40315"
                                    y="3.67595"
                                    width="24.4875"
                                    height="28.0198"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="3.11539"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter3_f_6089_41657"
                                    x="-6.40315"
                                    y="3.67595"
                                    width="24.4875"
                                    height="28.0198"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="3.11539"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter4_f_6089_41657"
                                    x="-6.11604"
                                    y="4.76427"
                                    width="24.5724"
                                    height="25.1192"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="3.11539"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter5_f_6089_41657"
                                    x="9.19416"
                                    y="-3.56036"
                                    width="23.1507"
                                    height="22.7317"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="2.96054"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter6_f_6089_41657"
                                    x="-11.8911"
                                    y="-5.00895"
                                    width="24.081"
                                    height="24.2726"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="2.6831"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter7_f_6089_41657"
                                    x="2.4983"
                                    y="-1.83855"
                                    width="24.3096"
                                    height="23.897"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="2.39611"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter8_f_6089_41657"
                                    x="4.18743"
                                    y="-5.69788"
                                    width="17.3424"
                                    height="15.9675"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="2.14408"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter9_f_6089_41657"
                                    x="-4.78495"
                                    y="-9.64549"
                                    width="21.8375"
                                    height="21.3596"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="1.81093"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <filter
                                    id="filter10_f_6089_41657"
                                    x="-4.36647"
                                    y="6.46111"
                                    width="17.105"
                                    height="15.8939"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="BackgroundImageFix"
                                        result="shape"
                                    />
                                    <feGaussianBlur
                                        stdDeviation="2.24134"
                                        result="effect1_foregroundBlur_6089_41657"
                                    />
                                </filter>
                                <linearGradient
                                    id="paint0_linear_6089_41657"
                                    x1="5.68535"
                                    y1="13.3818"
                                    x2="16.0731"
                                    y2="4.62397"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stop-color="#4893FC" />
                                    <stop offset="0.27" stop-color="#4893FC" />
                                    <stop
                                        offset="0.776981"
                                        stop-color="#969DFF"
                                    />
                                    <stop offset="1" stop-color="#BD99FE" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <span>{{ $t(tab.labelKey) }}</span>
                        <span
                            v-if="tab.key === activeInstallTab"
                            class="absolute bottom-0 left-0 h-[2px] w-full bg-[#FF421E]"
                        ></span>
                    </button>
                </div>
            </div>

            <div v-if="installContent" class="mt-[44px]">
                <div
                    class="flex items-start gap-2 rounded-md border border-[#FEF9C2] bg-[#FEF9C2] px-4 py-3 text-[12.25px] leading-[142%] text-[#744210] mb-[22px]"
                >
                    <svg
                        class="mt-[-1px] h-5 w-5 text-[#F0B100]"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5ZM8.25 9.75C8.25 9.55109 8.32902 9.36032 8.46967 9.21967C8.61032 9.07902 8.80109 9 9 9H9.253C9.51515 8.99989 9.77398 9.05867 10.0104 9.17201C10.2468 9.28536 10.4547 9.45036 10.6187 9.65483C10.7828 9.8593 10.8988 10.098 10.9582 10.3534C11.0176 10.6087 11.0189 10.8741 10.962 11.13L10.502 13.196C10.4939 13.2326 10.4941 13.2706 10.5027 13.3071C10.5113 13.3436 10.5279 13.3777 10.5514 13.4069C10.575 13.4361 10.6048 13.4596 10.6386 13.4757C10.6725 13.4918 10.7095 13.5001 10.747 13.5H11C11.1989 13.5 11.3897 13.579 11.5303 13.7197C11.671 13.8603 11.75 14.0511 11.75 14.25C11.75 14.4489 11.671 14.6397 11.5303 14.7803C11.3897 14.921 11.1989 15 11 15H10.747C10.4848 15.0001 10.226 14.9413 9.98963 14.828C9.75325 14.7146 9.54535 14.5496 9.38129 14.3452C9.21723 14.1407 9.10121 13.902 9.04179 13.6466C8.98237 13.3913 8.98108 13.1259 9.038 12.87L9.498 10.804C9.5061 10.7674 9.50586 10.7294 9.4973 10.6929C9.48874 10.6564 9.47208 10.6223 9.44856 10.5931C9.42503 10.5639 9.39524 10.5404 9.36139 10.5243C9.32754 10.5082 9.29049 10.4999 9.253 10.5H9C8.80109 10.5 8.61032 10.421 8.46967 10.2803C8.32902 10.1397 8.25 9.94891 8.25 9.75ZM10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7Z"
                            fill="currentColor"
                        />
                    </svg>
                    <span v-html="$t(installContent.warningHtmlKey)"></span>
                </div>

                <div
                    v-for="step in installContent.steps"
                    :key="step.number"
                    class="grid-cols-layout pb-5 lg:grid"
                >
                    <div class="mb-6 lg:mb-0 lg:mt-4">
                        <p class="text-[15.75px] font-semibold text-gray-700">
                            {{
                                $t("vue.mcp_install_step_label", {
                                    number: step.number,
                                })
                            }}
                        </p>
                        <p class="mt-1 text-[12.25px] text-gray-500">
                            {{ $t(step.titleKey) }}
                        </p>
                    </div>
                    <div
                        class="mx-auto w-full rounded-md bg-white shadow-card lg:mx-0"
                    >
                        <div class="p-6">
                            <ol
                                class="list-decimal space-y-1 pl-4 text-[12.25px] leading-[142%] text-[#4B5563] marker:text-[#4B5563]"
                            >
                                <li
                                    v-for="item in getNonEmphasisItems(
                                        step.items,
                                    )"
                                    :key="item.key"
                                >
                                    <span
                                        v-if="item.htmlKey"
                                        v-html="$t(item.htmlKey)"
                                    ></span>
                                    <span v-else>{{ $t(item.key) }}</span>
                                    <ul
                                        v-if="item.subitems"
                                        class="mt-2 list-none space-y-1 pl-4 text-[12.25px] leading-[142%] text-[#4B5563]"
                                    >
                                        <li
                                            v-for="subitem in item.subitems"
                                            :key="subitem.key"
                                        >
                                            <span
                                                v-if="subitem.htmlKey"
                                                v-html="$t(subitem.htmlKey)"
                                            ></span>
                                            <span v-else>
                                                {{ $t(subitem.key) }}
                                            </span>
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                            <p
                                v-if="getEmphasisItem(step)"
                                class="mt-1 text-[12.25px] leading-[142%] text-[#4B5563] italic"
                            >
                                <span
                                    v-if="getEmphasisItem(step)?.htmlKey"
                                    v-html="$t(getEmphasisItem(step)?.htmlKey)"
                                ></span>
                                <span v-else>
                                    {{ $t(getEmphasisItem(step)?.key ?? "") }}
                                </span>
                            </p>
                            <div v-if="step.assistant" class="mt-3">
                                <p
                                    class="text-[12.25px] leading-[142%] text-[#4B5563]"
                                >
                                    {{ $t(step.assistant.titleKey) }}
                                </p>
                                <ul
                                    class="mt-2 list-disc space-y-1 pl-4 text-[12.25px] leading-[142%] text-[#4B5563] marker:text-[#4B5563]"
                                >
                                    <li
                                        v-for="item in getNonEmphasisAssistantItems(
                                            step,
                                        )"
                                        :key="item.key"
                                    >
                                        {{ $t(item.key) }}
                                    </li>
                                </ul>
                                <p
                                    v-if="getAssistantEmphasisItem(step)"
                                    class="mt-1 pl-4 text-[12.25px] leading-[142%] text-[#4B5563] italic"
                                >
                                    {{
                                        $t(
                                            getAssistantEmphasisItem(step)
                                                ?.key ?? "",
                                        )
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="mt-[22px]">
                <div
                    class="mx-auto w-full rounded-md bg-white shadow-card lg:mx-0"
                >
                    <div
                        class="flex min-h-[160px] flex-col items-center justify-center gap-1 px-6 py-10 text-center"
                    >
                        <p class="text-[12.25px] font-medium text-gray-700">
                            {{ $t("vue.mcp_install_coming_soon_title") }}
                        </p>
                        <p class="text-[12.25px] text-gray-500">
                            {{ $t("vue.mcp_install_coming_soon_description") }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </SettingsTabs>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";

const MCP_ARTICLE_URL =
    "https://dmarceye.com/insights/dmarceye-mcp-server-bring-your-dmarc-data-into-llms";
const MCP_DOCS_URL =
    "https://docs.dmarceye.com/mcp-server-overview#mcp-server-overview";

const openMcpArticle = () => {
    window.open(MCP_ARTICLE_URL, "_blank", "noopener,noreferrer");
};

const openMcpDocs = () => {
    window.open(MCP_DOCS_URL, "_blank", "noopener,noreferrer");
};

const collapsedToolsCount = 4;
const showAllTools = ref(false);

const tools = [
    {
        name: "get-account-report",
        titleKey: "vue.mcp_tool_get_account_report_title",
        descriptionKey: "vue.mcp_tool_get_account_report_desc",
    },
    {
        name: "get-domain-ip-report",
        titleKey: "vue.mcp_tool_get_domain_ip_report_title",
        descriptionKey: "vue.mcp_tool_get_domain_ip_report_desc",
    },
    {
        name: "get-domain-report",
        titleKey: "vue.mcp_tool_get_domain_report_title",
        descriptionKey: "vue.mcp_tool_get_domain_report_desc",
    },
    {
        name: "get-domain-source-report",
        titleKey: "vue.mcp_tool_get_domain_source_report_title",
        descriptionKey: "vue.mcp_tool_get_domain_source_report_desc",
    },
    {
        name: "list-user-teams",
        titleKey: "vue.mcp_tool_list_user_teams_title",
        descriptionKey: "vue.mcp_tool_list_user_teams_desc",
    },
    {
        name: "list-team-users",
        titleKey: "vue.mcp_tool_list_team_users_title",
        descriptionKey: "vue.mcp_tool_list_team_users_desc",
    },
    {
        name: "list-domains-overview",
        titleKey: "vue.mcp_tool_list_domains_overview_title",
        descriptionKey: "vue.mcp_tool_list_domains_overview_desc",
    },
    {
        name: "list-alert-settings",
        titleKey: "vue.mcp_tool_list_alert_settings_title",
        descriptionKey: "vue.mcp_tool_list_alert_settings_desc",
    },
    {
        name: "list-blacklist-overview",
        titleKey: "vue.mcp_tool_list_blacklist_overview_title",
        descriptionKey: "vue.mcp_tool_list_blacklist_overview_desc",
    },
    {
        name: "list-report-settings",
        titleKey: "vue.mcp_tool_list_report_settings_title",
        descriptionKey: "vue.mcp_tool_list_report_settings_desc",
    },
    {
        name: "get-report-preview",
        titleKey: "vue.mcp_tool_get_report_preview_title",
        descriptionKey: "vue.mcp_tool_get_report_preview_desc",
    },
    {
        name: "send-user-email",
        titleKey: "vue.mcp_tool_send_user_email_title",
        descriptionKey: "vue.mcp_tool_send_user_email_desc",
    },
];

const visibleTools = computed(() =>
    showAllTools.value ? tools : tools.slice(0, collapsedToolsCount),
);

const hasMoreTools = computed(() => tools.length > collapsedToolsCount);

const toggleTools = () => {
    showAllTools.value = !showAllTools.value;
};

const installTabs = [
    {
        key: "chatgpt",
        labelKey: "vue.mcp_install_tab_chatgpt",
        enabled: true,
    },
    {
        key: "claude",
        labelKey: "vue.mcp_install_tab_claude",
        enabled: true,
    },
];

const activeInstallTab = ref("chatgpt");

const selectInstallTab = (tab: { key: string; enabled: boolean }) => {
    if (tab.enabled) {
        activeInstallTab.value = tab.key;
    }
};

const getEmphasisItem = (step: {
    items: Array<{ emphasis?: boolean; key: string; htmlKey?: string }>;
}) => step.items.find((item) => item.emphasis);

const getNonEmphasisItems = (
    items: Array<{ emphasis?: boolean; key: string; htmlKey?: string }>,
) => items.filter((item) => !item.emphasis);

const getAssistantEmphasisItem = (step: {
    assistant?: {
        items: Array<{ emphasis?: boolean; key: string }>;
    };
}) => step.assistant?.items.find((item) => item.emphasis);

const getNonEmphasisAssistantItems = (step: {
    assistant?: {
        items: Array<{ emphasis?: boolean; key: string }>;
    };
}) => step.assistant?.items.filter((item) => !item.emphasis) ?? [];

const chatgptSteps = [
    {
        number: 1,
        titleKey: "vue.mcp_install_step_1_title",
        items: [
            { key: "vue.mcp_install_step1_item1" },
            {
                key: "vue.mcp_install_step1_item2",
                htmlKey: "vue.mcp_install_step1_item2_html",
            },
            {
                key: "vue.mcp_install_step1_item3",
                htmlKey: "vue.mcp_install_step1_item3_html",
            },
        ],
    },
    {
        number: 2,
        titleKey: "vue.mcp_install_step_2_title",
        items: [
            { key: "vue.mcp_install_step2_item1" },
            {
                key: "vue.mcp_install_step2_item2",
                subitems: [
                    {
                        key: "vue.mcp_install_step2_item2_name",
                        htmlKey: "vue.mcp_install_step2_item2_name_html",
                    },
                    {
                        key: "vue.mcp_install_step2_item2_url",
                        htmlKey: "vue.mcp_install_step2_item2_url_html",
                    },
                ],
            },
            {
                key: "vue.mcp_install_step2_item3",
                htmlKey: "vue.mcp_install_step2_item3_html",
            },
            { key: "vue.mcp_install_step2_item4" },
        ],
    },
    {
        number: 3,
        titleKey: "vue.mcp_install_step_3_title",
        items: [
            { key: "vue.mcp_install_step3_item1" },
            { key: "vue.mcp_install_step3_item2" },
            { key: "vue.mcp_install_step3_item3" },
            { key: "vue.mcp_install_step3_item4" },
            {
                key: "vue.mcp_install_step3_item5",
                emphasis: true,
            },
        ],
    },
    {
        number: 4,
        titleKey: "vue.mcp_install_step_4_title",
        items: [
            { key: "vue.mcp_install_step4_item1" },
            { key: "vue.mcp_install_step4_item2" },
            { key: "vue.mcp_install_step4_item3" },
        ],
        assistant: {
            titleKey: "vue.mcp_install_step4_assistant_title",
            items: [
                { key: "vue.mcp_install_step4_assistant_item1" },
                { key: "vue.mcp_install_step4_assistant_item2" },
                { key: "vue.mcp_install_step4_assistant_item3" },
                {
                    key: "vue.mcp_install_step4_assistant_item4",
                    emphasis: true,
                },
            ],
        },
    },
];

const claudeSteps = [
    {
        number: 1,
        titleKey: "vue.mcp_install_step_1_title",
        items: [
            { key: "vue.mcp_install_claude_step1_item1" },
            {
                key: "vue.mcp_install_claude_step1_item2",
                htmlKey: "vue.mcp_install_claude_step1_item2_html",
            },
        ],
    },
    {
        number: 2,
        titleKey: "vue.mcp_install_step_2_title",
        items: [
            { key: "vue.mcp_install_claude_step2_item1" },
            {
                key: "vue.mcp_install_claude_step2_item2",
                subitems: [
                    {
                        key: "vue.mcp_install_claude_step2_item2_name",
                        htmlKey: "vue.mcp_install_claude_step2_item2_name_html",
                    },
                    {
                        key: "vue.mcp_install_claude_step2_item2_url",
                        htmlKey: "vue.mcp_install_claude_step2_item2_url_html",
                    },
                ],
            },
            { key: "vue.mcp_install_claude_step2_item3" },
        ],
    },
    {
        number: 3,
        titleKey: "vue.mcp_install_step_3_title",
        items: [
            { key: "vue.mcp_install_claude_step3_item1" },
            { key: "vue.mcp_install_claude_step3_item2" },
            { key: "vue.mcp_install_claude_step3_item3" },
            { key: "vue.mcp_install_claude_step3_item4" },
            {
                key: "vue.mcp_install_claude_step3_item5",
                emphasis: true,
            },
        ],
    },
    {
        number: 4,
        titleKey: "vue.mcp_install_step_4_title",
        items: [
            { key: "vue.mcp_install_claude_step4_item1" },
            { key: "vue.mcp_install_claude_step4_item2" },
            { key: "vue.mcp_install_claude_step4_item3" },
        ],
    },
];

const installContent = computed(() => {
    if (activeInstallTab.value === "chatgpt") {
        return {
            warningHtmlKey: "vue.mcp_install_requires_chatgpt_html",
            steps: chatgptSteps,
        };
    }

    if (activeInstallTab.value === "claude") {
        return {
            warningHtmlKey: "vue.mcp_install_requires_claude_html",
            steps: claudeSteps,
        };
    }

    return null;
});
</script>
